import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { EditedPoint } from '../../../../../../interfaces/edit-route.interface';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { SuggestedPoint } from '../../../../../../interfaces/edit-route.response';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    TranslateModule,
    DurationPipe,
  ],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {
  public point = input.required<SuggestedPoint>();


}
